import { httpClient } from './httpClient';

const base = '/api/roles';

export const listarRoles = () => httpClient.get(base);
export const obtenerRol = (id) => httpClient.get(`${base}/${id}`);
export const crearRol = (payload) => httpClient.post(base, payload);
export const actualizarRol = (id, payload) => httpClient.put(`${base}/${id}`, payload);
export const eliminarRol = (id) => httpClient.del(`${base}/${id}`);

const rolesService = {
  listar: listarRoles,
  obtener: obtenerRol,
  crear: crearRol,
  actualizar: actualizarRol,
  eliminar: eliminarRol,
};

export default rolesService;
